<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600px"
    @keydown.esc="() => {}"
  >
    <v-card>
      <!-- Header simplificado -->
      <v-card-title class="header-section pa-6">
        <v-icon large class="mr-3" color="#2b58e2">
          mdi-file-document-outline
        </v-icon>
        <div>
          <div class="text-h5 font-weight-bold" style="word-break: normal">
            {{ $t("termsAndConditions.title") }}
          </div>
          <div class="text-subtitle-2 mt-1 text--secondary">
            {{ $t("termsAndConditions.subtitle") }}
          </div>
        </div>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Botón para mostrar/ocultar términos -->
      <div class="text-center pa-4">
        <v-btn
          @click="showTermsContent = !showTermsContent"
          outlined
          color="#9e9e9e"
          class="terms-toggle-btn"
        >
          <v-icon left>{{
            showTermsContent ? "mdi-eye-off" : "mdi-eye"
          }}</v-icon>
          {{
            showTermsContent
              ? $t("termsAndConditions.hideTerms")
              : $t("termsAndConditions.viewTerms")
          }}
        </v-btn>
      </div>

      <v-card-text v-if="showTermsContent" class="pa-0">
        <div
          class="terms-content pa-6"
          style="max-height: 400px; overflow-y: auto"
        >
          <p class="text-body-1 mb-4">
            {{ $t("termsAndConditions.content.intro") }}
          </p>

          <p class="text-body-1 mb-4">
            {{ $t("termsAndConditions.content.statement") }}
          </p>

          <p class="text-body-1 mb-4 font-weight-medium">
            {{ $t("termsAndConditions.content.acknowledgment") }}
          </p>

          <!-- Sección 1 -->
          <div class="section-item mb-4">
            <h4 class="section-title mb-2">
              {{ $t("termsAndConditions.content.section1.title") }}
            </h4>
            <p class="section-text" style="white-space: pre-line">
              {{ $t("termsAndConditions.content.section1.text") }}
            </p>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Sección 2 -->
          <div class="section-item mb-4">
            <h4 class="section-title mb-2">
              {{ $t("termsAndConditions.content.section2.title") }}
            </h4>
            <p class="section-text" style="white-space: pre-line">
              {{ $t("termsAndConditions.content.section2.text") }}
            </p>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Sección 3 -->
          <div class="section-item mb-4">
            <h4 class="section-title mb-2">
              {{ $t("termsAndConditions.content.section3.title") }}
            </h4>
            <p class="section-text" style="white-space: pre-line">
              {{ $t("termsAndConditions.content.section3.text") }}
            </p>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Sección 4 -->
          <div class="section-item mb-4">
            <h4 class="section-title mb-2">
              {{ $t("termsAndConditions.content.section4.title") }}
            </h4>
            <p class="section-text" style="white-space: pre-line">
              {{ $t("termsAndConditions.content.section4.text") }}
            </p>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Sección 5 -->
          <div class="section-item mb-4">
            <h4 class="section-title mb-2">
              {{ $t("termsAndConditions.content.section5.title") }}
            </h4>
            <p class="section-text" style="white-space: pre-line">
              {{ $t("termsAndConditions.content.section5.text") }}
            </p>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Sección 6 -->
          <div class="section-item mb-4">
            <h4 class="section-title mb-2">
              {{ $t("termsAndConditions.content.section6.title") }}
            </h4>
            <p class="section-text" style="white-space: pre-line">
              {{ $t("termsAndConditions.content.section6.text") }}
            </p>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Sección 7 -->
          <div class="section-item mb-4">
            <h4 class="section-title mb-2">
              {{ $t("termsAndConditions.content.section7.title") }}
            </h4>
            <p class="section-text" style="white-space: pre-line">
              {{ $t("termsAndConditions.content.section7.text") }}
            </p>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Sección 8 -->
          <div class="section-item mb-4">
            <h4 class="section-title mb-2">
              {{ $t("termsAndConditions.content.section8.title") }}
            </h4>
            <p class="section-text" style="white-space: pre-line">
              {{ $t("termsAndConditions.content.section8.text") }}
            </p>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Sección 9 -->
          <div class="section-item mb-4">
            <h4 class="section-title mb-2">
              {{ $t("termsAndConditions.content.section9.title") }}
            </h4>
            <p class="section-text" style="white-space: pre-line">
              {{ $t("termsAndConditions.content.section9.text") }}
            </p>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Sección 10 -->
          <div class="section-item mb-4">
            <h4 class="section-title mb-2">
              {{ $t("termsAndConditions.content.section10.title") }}
            </h4>
            <p class="section-text" style="white-space: pre-line">
              {{ $t("termsAndConditions.content.section10.text") }}
            </p>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Sección 11 -->
          <div class="section-item mb-4">
            <h4 class="section-title mb-2">
              {{ $t("termsAndConditions.content.section11.title") }}
            </h4>
            <p class="section-text" style="white-space: pre-line">
              {{ $t("termsAndConditions.content.section11.text") }}
            </p>
          </div>

          <!-- Alert de aceptación simplificado -->
          <v-alert
            class="mt-4 acceptance-alert"
            type="info"
            border="left"
            elevation="1"
          >
            <strong class="acceptance-text">
              {{ $t("termsAndConditions.content.acceptance") }}
            </strong>
          </v-alert>
        </div>
      </v-card-text>

      <v-divider v-if="showTermsContent"></v-divider>

      <!-- Texto informativo centrado -->
      <div class="text-center pa-3">
        <p class="mb-0 text-body-2" style="color: #424242; font-weight: 500">
          {{ $t("termsAndConditions.acceptMessage") }}
        </p>
      </div>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          class="reject-btn mr-3"
          outlined
          @click="reject"
          :disabled="loading"
        >
          {{ $t("termsAndConditions.reject") }}
        </v-btn>
        <v-btn class="accept-btn" @click="accept" :loading="loading">
          {{ $t("termsAndConditions.accept") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import user from "@/api/user.js";
import * as Sentry from "@sentry/vue";

export default {
  name: "TermsAndConditionsDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: this.value,
      loading: false,
      showTermsContent: false,
    };
  },
  watch: {
    value(newVal) {
      this.dialog = newVal;
    },
    dialog(newVal) {
      this.$emit("input", newVal);
    },
  },
  methods: {
    async accept() {
      this.loading = true;
      try {
        // Actualizar tos_signed a true en el backend
        const userData = {
          tos_signed: true,
        };

        const response = await user.updateUser(userData);

        if (response.code === 200) {
          // Actualizar el store local
          this.$store.commit("setUser", {
            ...this.$store.getters.getUser,
            tos_signed: true,
          });

          this.$emit("accepted");
          this.dialog = false;
        } else {
          this.$emit("error", "Error al aceptar los términos y condiciones");
        }
      } catch (error) {
        Sentry.captureException(error);
        console.error("Error updating terms acceptance:", error);
        // Mostrar error al usuario
        this.$emit("error", "Error al aceptar los términos y condiciones");
      } finally {
        this.loading = false;
      }
    },

    reject() {
      this.$emit("rejected");
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
/* Header */
.header-section {
  background-color: #fafafa;
  border-bottom: 1px solid #e0e0e0;
}

/* Contenido */
.terms-content {
  line-height: 1.6;
}

/* Scrollbar personalizada */
.terms-content::-webkit-scrollbar {
  width: 6px;
}

.terms-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.terms-content::-webkit-scrollbar-thumb {
  background: #2b58e2;
  border-radius: 3px;
}

.terms-content::-webkit-scrollbar-thumb:hover {
  background: #1e3f8f;
}

/* Secciones */
.section-item {
  padding: 16px;
  border-radius: 11px;
  background-color: #fafafa;
  border: 1px solid #e0e0e0;
}

.section-title {
  color: #2b58e2 !important;
  font-weight: 600 !important;
  font-size: 1.1rem !important;
}

.section-text {
  color: #424242 !important;
  line-height: 1.6 !important;
  text-align: justify;
  margin-bottom: 0;
}

/* Alert de aceptación */
.acceptance-alert {
  background-color: rgba(43, 88, 226, 0.05) !important;
  border-left: 4px solid #2b58e2 !important;
}

.acceptance-text {
  color: #2b2c30 !important;
  font-size: 0.95rem !important;
}

/* Botones */
.terms-toggle-btn {
  border: 1px solid #e0e0e0 !important;
  color: #9e9e9e !important;
  font-weight: 400 !important;
  border-radius: 11px !important;
  transition: all 0.3s ease !important;
  background-color: transparent !important;
  font-size: 0.8rem !important;
  opacity: 0.7 !important;
}

.terms-toggle-btn:hover {
  background-color: #f5f5f5 !important;
  color: #757575 !important;
  opacity: 0.9 !important;
}

.reject-btn {
  border: 2px solid #d32f2f !important;
  color: #d32f2f !important;
  font-weight: 600 !important;
  border-radius: 11px !important;
  transition: all 0.3s ease !important;
}

.reject-btn:hover {
  background-color: #d32f2f !important;
  color: white !important;
}

.accept-btn {
  background-color: #2b2c30 !important;
  color: white !important;
  font-weight: 600 !important;
  border-radius: 11px !important;
  transition: all 0.3s ease !important;
}

.accept-btn:hover {
  background-color: #1a1b1e !important;
}

/* Responsive */
@media (max-width: 600px) {
  .terms-content {
    max-height: 300px !important;
  }

  .section-item {
    padding: 12px;
  }

  .reject-btn,
  .accept-btn {
    min-width: 100px !important;
  }
}
</style>
